import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { preventNodeRemovalOnType } from '@/components/ui/tiptap/plugins';

import { VideoNodeComponent, type VideoOptions } from '.';

export const VideoNode = Node.create<VideoOptions>({
  name: 'video-node',
  group: 'block',
  atom: true,
  draggable: true,
  allowGapCursor: false,
  addProseMirrorPlugins() {
    const type = this.type;
    return [preventNodeRemovalOnType(type)];
  },

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },
  addAttributes() {
    return {
      src: {
        default: null,
      },
      fileType: {
        default: null,
      },
      title: {
        default: null,
      },
      poster: {
        default: null,
      },
      maxWidth: {
        default: 460,
      },
      maxHeight: {
        default: null,
      },
      textAlign: {
        default: 'left',
      },
    };
  },

  selectable() {
    return this.editor?.isEditable ?? false;
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="video-node"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-type': 'video-node',
      }),
    ];
  },

  addCommands() {
    return {
      setVideo:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(VideoNodeComponent);
  },
});
